import React from 'react'
import WhetherIconContainer from '../../../Components/Icons/WhetherIcon'

export default function WhetherIcon() {
  
  return (
    <div className='page-body'>
        <WhetherIconContainer/>
    </div>
  )
}
